"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const Button_1 = __importDefault(require("../Util/Button"));
const AccordionContext_1 = __importDefault(require("../../contexts/AccordionContext"));
const AccordionHeader = (props) => {
    const { children, onClick: onClickFromProps } = props;
    const { open, setOpen, onOpen, onClose, onChange } = react_1.useContext(AccordionContext_1.default);
    const onClickHandle = react_1.useCallback((e) => {
        const newOpen = !open;
        if (newOpen) {
            onOpen === null || onOpen === void 0 ? void 0 : onOpen(e);
        }
        else {
            onClose === null || onClose === void 0 ? void 0 : onClose(e);
        }
        setOpen(newOpen);
        onClickFromProps === null || onClickFromProps === void 0 ? void 0 : onClickFromProps(e);
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    }, [onChange, onClickFromProps, onClose, onOpen, open, setOpen]);
    return (react_1.default.createElement(Button_1.default, Object.assign({}, props, { onClick: onClickHandle, className: classnames_1.default(props.className, { open }) }), children));
};
exports.default = withJourney_1.default('j-accordion-header', AccordionHeader);
